import {
  IonAccordion,
  IonAccordionGroup,
  IonAlert,
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonContent,
  IonFab,
  IonFabButton,
  IonFabList,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonSegment,
  IonSegmentButton,
  IonText,
  useIonViewWillLeave,
} from "@ionic/react";
import { isEmpty } from "underscore";
import {
  add,
  ellipsisHorizontal,
  informationCircle,
  trashOutline,
  trendingUpOutline,
} from "ionicons/icons";
import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useContext,
} from "react";
import AppPrefContext from "../../../components/contexts/AppPrefContext";
import { v4 as uuidv4 } from "uuid";
import config from "../../../components/helpers/socket/config";
import { send } from "../../../utils/sockets/asyncSocket";
import { CMEDPermissions } from "../MarketData/MarketDataContent";
import OptionsGridListItem from "./OptionsGridListItem";
import OptionsGridViewModal from "./OptionsGridViewModal";
import optionsGridConfig from "./optionsGridConfig";
import { groupAndSortStrikes } from "./utils";
import PubSub from "pubsub-js";
import "../OptionsGrid/styles__optionsgrid.css";
import RenderTable from "../common/components/RenderTable";
import OneLoader from "../../../utils/component-utils/Loader/OneLoader";
import { unsubscribeStrikeLadder } from "./unsubscribeStrikeLadder";
import firebaseEventConfig from "../../../utils/firebaseAnalytics/firebaseEventConfig";
import { CMEDfirebaseLogEvent } from "../../../utils/firebaseAnalytics/firebaseUtils";
import { OrdersType } from "../../../Constants";
import Skeleton__OptionsGrid from "./skeletons/Skeleton__OptionsGrid";
/**
 * @author
 * E45597 Aryamitra Chaudhuri
 * E47440 Vithal Agrawal
 */

type Data = {
  id: string;
  v: string;
  u: string;
  uf: string;
  i: boolean;
  c: string;
  b: { r: number; f: string };
  bb: { r: number; f: string };
  bo: { r: number; f: string };
  boq: { r: number; f: string };
  l: any;
  lt: number;
  t: any;
  n: any;
  tt: any;
  ii: string;
  ts: string;
};

type OptionsGridProps = {
  greekType?: any;
  setgreekType: any;
  isMidStrikeValue?: number;
  isOptionsGridViewModalOpen: boolean;
  setIsOptionsGridViewModalOpen: Function;
  selectedOption: any;
  userCMEDEntitlements: CMEDPermissions | undefined;
  persistedOptionGrids: any;
  setPersistedOptionGrids: any;
  setdeletedOptionGridIndex: any;
  setselectedOption_Super: any;
  optionGrids: any;
  setSelectedExpiryId: any;
};
const OptionsGrid: React.FC<OptionsGridProps> = ({
  greekType,
  setgreekType,
  isMidStrikeValue,
  isOptionsGridViewModalOpen,
  setIsOptionsGridViewModalOpen,
  selectedOption,
  userCMEDEntitlements,
  persistedOptionGrids,
  setPersistedOptionGrids,
  setdeletedOptionGridIndex,
  setselectedOption_Super,
  optionGrids,
  setSelectedExpiryId,
}) => {
  const appPref = useContext(AppPrefContext);
  const reqIdref = useRef("");

  const [fabButtonOptions, setFabButtonOptions] = useState<boolean>(false);

  const [selectedDerivativeType, setSelectedDerivativeType] = useState("calls");
  const [selectedOptionfromList, setSelectedOptionfromList] =
    useState<any>(undefined);

  const [openOrderAggressionModal, setopenOrderAggressionModal] =
    useState<any>(undefined);

  const [optionsGridGroup, setOptionsGridGroup] = useState<any>(undefined);
  const [optionGridData, setoptionGridData] = useState<any>(undefined);

  const [selectedStrike, setSelectedStrike] = useState<string>();

  const [strikePriceATM, setStrikePriceATM] = useState<boolean>(true);

  const [strikePrice, setStrikePrice] = useState<string>("");

  const [orderEntryData, setOrderEntryData] = useState<any>();
  const [orderEntryData_Live, setOrderEntryData_Live] = useState<any>();

  const [orderAggressionCall, setorderAggressionCall] = useState("");

  const [orderAggressionPut, setorderAggressionPut] = useState("");

  const [openOrderEntryModal, setOpenOrderEntryModal] = useState(false);

  const [orderEntryType, setOrderEntryType] = useState<string>();

  const [type, setType] = useState<string>("call");

  const [isUpdateStrikeAlertOpen, setIsUpdateStrikeAlertOpen] = useState(false);

  const [isLoadingOptionGrid, setIsLodingOptionGrid] = useState<boolean>(true);
  const nearestStrikePrice = useRef();

  const prevSelectedOptionCode = useRef<string>();

  const [isWaitTimeOver, setIsWaitTimeOver] = useState<boolean>(false);
  const noDataTimerRef = useRef<NodeJS.Timeout | null>(null);
  const [isNewOption, setIsNewOption] = useState<boolean>(false);

  const persistNewOptionGrid = (gridToPersist: any) => {
    const arr = [
      {
        optionCategory: gridToPersist.OptionCategory,
        TermStructureCode: gridToPersist.TermStructureCode,
        TermStructureDescription: gridToPersist.TermStructureDescription,
        greekSource: gridToPersist.greekSource || greekType.toString(),
        greeksEnabled: true,
        expiryTs: gridToPersist.expiryTs,
        id: gridToPersist.id,
      },
    ];
    send(config.socket.channels.CORE, {
      action: "savePersistedOptionGrids",
      type: "legacyValidation",
      requestID: uuidv4(),
      payload: arr && arr.length > 0 ? arr : [],
    });
  };

  const setOptionGridGroupData = useCallback(
    (res: any) => {
      const { data: payload, identifier } = res.payload;
      const termStructureCode = payload?.[0]?.id;
      if (!termStructureCode) {
        if (isEmpty(payload)) {
          const expiredContract = optionGrids?.find(
            (grid: any) => grid.TermStructureCode === identifier,
          );
          if (expiredContract) removeOptionGrid(expiredContract);
        }
        return;
      }
      const matchingGrid = optionGrids?.find(
        (grid: any) => grid.TermStructureCode === termStructureCode,
      );
      if (termStructureCode !== selectedOption?.TermStructureCode) {
        unsubscribeStrikeLadder(matchingGrid);
      }

      if (
        payload?.[0]?.tt !== null &&
        matchingGrid.id &&
        !matchingGrid.expiryTs
      ) {
        const updatedMatchingGrid = {
          ...matchingGrid,
          expiryTs: payload[0].tt,
        };
        persistNewOptionGrid(updatedMatchingGrid);
      }
      if (res.payload.isSnapshot) {
        const value = payload[0];
        setOptionsGridGroup(value);
        // setIsNewOption(true);
        reqIdref.current = value.id;
      } else if (res.payload.data.length) {
        const value = payload[0];
        if (value.id === reqIdref.current) {
          setOptionsGridGroup(value);
        }
      }
    },
    [optionGrids, selectedOption?.TermStructureCode],
  );

  const processDataRef = useRef(setOptionGridGroupData);

  useEffect(() => {
    processDataRef.current = setOptionGridGroupData;
  }, [setOptionGridGroupData]);

  useEffect(() => {
    const optionGridDataItemsSubscription = PubSub.subscribe(
      optionsGridConfig.socketKeys.CMED_ADD_CONTRACTS_LADDER,
      async (msg, data) => {
        setOptionGridDataItems(data);
      },
    );
    const optionGridGroupDataSubscription = PubSub.subscribe(
      optionsGridConfig.socketKeys.CMED_ADD_CONTRACTS,
      async (msg, data) => {
        processDataRef.current(data);
      },
    );

    return () => {
      PubSub.unsubscribe(optionGridDataItemsSubscription);
      PubSub.unsubscribe(optionGridGroupDataSubscription);
    };
  }, []);

  useEffect(() => {
    const notAvailableExpiryTsList = persistedOptionGrids?.filter(
      (grid: any) => !grid.expiryTs,
    );
    if (notAvailableExpiryTsList && notAvailableExpiryTsList.length > 0) {
      notAvailableExpiryTsList?.map((contract: Object) => {
        subscribeMultipleStrikeLadder(contract);
      });
    }
  }, [persistedOptionGrids]);

  useEffect(() => {
    const isOptionChanged =
      selectedOption?.TermStructureCode !== prevSelectedOptionCode.current;

    if (isOptionChanged) {
      resetState();
    } else {
      setIsNewOption(false);
    }
    if (selectedOption && appPref?.isAppActive) {
      reqIdref.current = selectedOption.id;
      if (!strikePriceATM && strikePrice) {
        subscribeStrikeLadderCustom(strikePrice);
      } else {
        greekType?.length > 0
          ? subscribeStrikeLadderCustom("")
          : isMidStrikeValue
            ? subscribeStrikeLadder(selectedOption)
            : subscribeStrikeLadderWithoutStrike();
      }
    }

    prevSelectedOptionCode.current = selectedOption?.TermStructureCode;
  }, [selectedOption?.TermStructureCode, appPref?.isAppActive]);

  useIonViewWillLeave(() => {
    setFabButtonOptions(false);
  });

  useEffect(() => {
    if (isMidStrikeValue) setStrikePrice(`${isMidStrikeValue}`);
    else setStrikePrice(strikePrice);
  }, []);

  useEffect(() => {
    nearestStrikePrice.current = findNearestStrike(
      optionGridData,
      strikePrice,
      strikePriceATM,
    );
  }, [optionGridData, strikePrice, strikePriceATM]);

  useEffect(() => {
    if (isNewOption && optionGridData) {
      const timeoutId = setTimeout(() => {
        const elem = document.getElementById("focuseditem");
        if (elem) {
          elem.scrollIntoView({ block: "center" });
          elem.removeAttribute("id");
          setIsNewOption(false);
        }
      }, 200);
      return () => clearTimeout(timeoutId);
    }
  }, [optionGridData, isNewOption]);

  useEffect(() => {
    if (selectedStrike && optionGridData && optionGridData.length > 0) {
      const selectedStrikeNum = parseFloat(selectedStrike);
      const matchingRow = optionGridData.find(
        (row: any) => row.key === selectedStrikeNum,
      );
      if (matchingRow) {
        setOrderEntryData(matchingRow);
        setOrderEntryData_Live(matchingRow);
      }
    }
  }, [optionGridData, selectedStrike]);

  useEffect(() => {
    if (optionGridData && optionGridData.length > 0) {
      setIsLodingOptionGrid(false);
      setIsWaitTimeOver(false);
      if (noDataTimerRef.current) {
        clearTimeout(noDataTimerRef.current);
      }
      return;
    }
    if (isLoadingOptionGrid) {
      if (noDataTimerRef.current) {
        clearTimeout(noDataTimerRef.current);
      }
      setIsWaitTimeOver(false);

      noDataTimerRef.current = setTimeout(() => {
        setIsLodingOptionGrid(false);
        setIsWaitTimeOver(true);
      }, 3000);
    }
    return () => {
      if (noDataTimerRef.current) {
        clearTimeout(noDataTimerRef.current);
      }
    };
  }, [isLoadingOptionGrid, optionGridData]);

  function removeOptionGrid(data: any) {
    unsubscribeStrikeLadder(data);

    if (!persistedOptionGrids) return;

    const index = persistedOptionGrids.findIndex(
      (item: any) => item.TermStructureCode === data.TermStructureCode,
    );

    if (index === -1) return;

    setdeletedOptionGridIndex(index);

    const itemToDelete = persistedOptionGrids[index];
    deletePersistedOptionHandler(itemToDelete.id);

    const updatedGrids = persistedOptionGrids.filter(
      (item: any) => item.TermStructureCode !== data.TermStructureCode,
    );

    setPersistedOptionGrids(updatedGrids);
  }

  const deletePersistedOptionHandler = (id: any) => {
    send(config.socket.channels.CORE, {
      action: "deletePersistedOptionGrids",
      type: "deletePersistedOptionGrids",
      requestID: uuidv4(),
      payload: { id: id },
    });
  };

  const resetState = () => {
    setoptionGridData(undefined);
    setOptionsGridGroup(undefined);
    setSelectedStrike(undefined);
    setStrikePriceATM(true);
    setStrikePrice("");
    setIsLodingOptionGrid(true);
    setIsNewOption(true);
  };

  function setOptionGridDataItems(res: any) {
    const payload: Data[] = res.payload.data;
    const identifier: string = res.payload.identifier;
    const sortedDataByStrikes = groupAndSortStrikes(payload);

    if (reqIdref.current === identifier) {
      if (isEmpty(payload) && isEmpty(res.payload.deletions)) {
        setoptionGridData(undefined);
        setIsLodingOptionGrid(true);
        return;
      }

      if (res.payload.isSnapshot) {
        setoptionGridData(sortedDataByStrikes);
        // setIsNewOption(true);
      } else {
        if (payload.length) {
          setoptionGridData((prevObjects: any) => {
            let updatedObjects: any[];
            if (prevObjects) {
              updatedObjects = [...prevObjects];
              updatedObjects?.map((p: any, index1: any) => {
                //existing data
                sortedDataByStrikes?.map((e: any, index2: any) => {
                  // new data
                  if (p["key"] === e["key"]) {
                    // matching strike
                    p["data"]?.map((q: any, index3: any) => {
                      // over old data - for each
                      e["data"]?.map((r: any, index4: any) => {
                        // new data - for each
                        // match id - find index - update index of array in the obj
                        // const objectIndex = q.findIndex((obj:any) => obj.id === r.id);
                        // q[objectIndex] = r
                        if (q?.id === r?.id) {
                          updatedObjects[index1]["data"][index3] = r;
                        }
                      });
                    });
                  }
                });
              });
              return updatedObjects?.length > 0 ? updatedObjects : undefined;
            } else {
              return sortedDataByStrikes;
            }
          });
        }
      }
    }
  }

  function subscribeStrikeLadder(selectedOption: any) {
    let request = {
      action:
        optionsGridConfig.socket.actions
          .CMED_OPTIONSGRID_SUBSCRIBE_STRIKELADDER,
      type: OrdersType.OPTIONS_GRID_GROUP,
      requestID: uuidv4(),
      payload: {
        termStructureCode: selectedOption?.TermStructureCode,
        strikes: "31",
        atm: "false",
        midStrike: isMidStrikeValue,
      },
    };
    send(config.socket.channels.TRADING, request);
  }

  function subscribeStrikeLadderWithoutStrike() {
    let request = {
      action:
        optionsGridConfig.socket.actions
          .CMED_OPTIONSGRID_SUBSCRIBE_STRIKELADDER,
      type: OrdersType.OPTIONS_GRID_GROUP,
      requestID: uuidv4(),
      payload: {
        termStructureCode: selectedOption.TermStructureCode,
        strikes: "31",
        atm: "true",
      },
    };
    send(config.socket.channels.TRADING, request);
  }

  function subscribeMultipleStrikeLadder(contractData: any) {
    let request = {
      action:
        optionsGridConfig.socket.actions
          .CMED_OPTIONSGRID_SUBSCRIBE_STRIKELADDER,
      type: OrdersType.OPTIONS_GRID_GROUP,
      requestID: uuidv4(),
      payload: {
        termStructureCode: contractData?.TermStructureCode,
        strikes: "31",
        atm: "true",
        greeksSource: greekType?.toString(),
      },
    };
    send(config.socket.channels.TRADING, request);
  }

  function subscribeStrikeLadderCustom(strike: string) {
    let request = {
      action:
        optionsGridConfig.socket.actions
          .CMED_OPTIONSGRID_SUBSCRIBE_STRIKELADDER,
      type: OrdersType.OPTIONS_GRID_GROUP,
      requestID: uuidv4(),
      payload:
        strike === ""
          ? {
              termStructureCode: selectedOption.TermStructureCode,
              strikes: "31",
              atm: "true",
              greeksSource: greekType?.toString(),
            }
          : {
              termStructureCode: selectedOption.TermStructureCode,
              strikes: "31",
              atm: "false",
              midStrike: strike,
              greeksSource: greekType?.toString(),
            },
    };
    send(config.socket.channels.TRADING, request);
  }

  const data = [
    {
      bidq: optionsGridGroup?.b?.f ?? "",
      bid: optionsGridGroup?.bb?.f ?? "",
      offer: optionsGridGroup?.bo?.f ?? "",
      offerq: optionsGridGroup?.boq?.f ?? "",
    },
  ];
  const headings = [
    { heading: "BID QTY", align: "alignLeft", id: 1 },
    { heading: "BID", align: "alignRight", id: 2 },
    { heading: "OFFER", align: "alignLeft", id: 3 },
    { heading: "OFFER QTY", align: "alignRight", id: 4 },
  ];

  function findNearestStrike(
    optionGridData: any[],
    strikePrice: string | number,
    strikePriceATM: boolean,
  ): any | undefined {
    if (!optionGridData || optionGridData.length === 0 || strikePriceATM) {
      return undefined; // Handle empty data or ATM case
    }

    const targetStrike =
      typeof strikePrice === "string" ? parseFloat(strikePrice) : strikePrice;

    if (isNaN(targetStrike)) {
      return undefined; // Handle invalid strikePrice
    }

    // Boundary guards to prevent floating-point precision loss with extremely large/small numbers
    if (targetStrike <= optionGridData[0]["key"]) {
      return optionGridData[0]["key"];
    }
    if (targetStrike >= optionGridData[optionGridData.length - 1]["key"]) {
      return optionGridData[optionGridData.length - 1]["key"];
    }

    let nearestStrike = optionGridData[0];
    let minDifference = Math.abs(targetStrike - nearestStrike["key"]);

    for (let i = 1; i < optionGridData.length; i++) {
      const currentStrike = optionGridData[i];
      const currentDifference = Math.abs(targetStrike - currentStrike["key"]);

      if (currentDifference < minDifference) {
        minDifference = currentDifference;
        nearestStrike = currentStrike;
      }
    }
    return nearestStrike?.key;
  }

  return (
    <React.Fragment>
      {optionGrids.length != 0 && !isLoadingOptionGrid ? (
        <>
          <IonHeader className="ion-no-border">
            {optionGridData && optionGridData.length > 0 && (
              <>
                <div className="optionsgrid_header_section">
                  <h1>Underlying Future</h1>
                  <IonAccordionGroup className="underlying_future">
                    <IonAccordion value="first">
                      <IonItem slot="header">
                        <div className="item-content">
                          <IonLabel className="ion-text-wrap">
                            {optionsGridGroup !== undefined &&
                              optionsGridGroup.u}
                          </IonLabel>
                        </div>
                      </IonItem>
                      <div className="ion-no-padding" slot="content">
                        <RenderTable
                          tableHeadings={headings}
                          tableData={data}
                          colsRight={["bid", "offerq"]}
                        />
                      </div>
                    </IonAccordion>
                  </IonAccordionGroup>
                  <IonSegment
                    value={selectedDerivativeType}
                    className="tab_based_segment"
                    onIonChange={(e: any) =>
                      setSelectedDerivativeType(e.detail.value)
                    }
                  >
                    <IonSegmentButton
                      value="calls"
                      className="tab_based_segment_button"
                    >
                      <IonLabel>CALLS</IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton
                      value="puts"
                      className="tab_based_segment_button"
                    >
                      <IonLabel>PUTS</IonLabel>
                    </IonSegmentButton>
                  </IonSegment>
                </div>
                <IonItem
                  className="ion-no-padding"
                  lines="none"
                  style={{
                    "--inner-padding-end": 0,
                    "--min-height": "0px",
                    "--background": "none",
                  }}
                >
                  <div className="optionsgrid_header_parent">
                    <div className="strike_header">STRIKE</div>
                    <div className="bid_qty_header">
                      BID
                      <br />
                      QTY
                    </div>
                    <div className="offer_qty_header">
                      OFFER
                      <br />
                      QTY
                    </div>
                    <div className="last_theo_header">
                      LAST
                      <br />
                      THEO
                    </div>
                    <div className="delta_vol_header">
                      DELTA
                      <br />
                      VOL
                    </div>
                  </div>
                </IonItem>
              </>
            )}
          </IonHeader>
          {/* %%% main data display %%% */}
          <IonContent>
            {(optionGridData === undefined || optionGridData.length === 0) &&
              !isLoadingOptionGrid &&
              isWaitTimeOver && (
                <IonCard color="light">
                  <IonCardHeader>
                    <IonCardTitle>No strike data available</IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent>
                    There was no grid data returned for the selected options
                    instrument, as it may have expired. Click below to remove
                    it.
                  </IonCardContent>
                  <IonButton
                    color="danger"
                    fill="clear"
                    onClick={() => {
                      removeOptionGrid(selectedOption);
                    }}
                  >
                    <IonIcon icon={trashOutline} slot="start" />
                    Remove
                  </IonButton>
                </IonCard>
              )}
            {optionGridData !== undefined &&
              optionGridData.length > 0 &&
              optionGridData.map((e: any, index: any) => {
                const { data } = e;
                return (
                  <OptionsGridListItem
                    key={e.id}
                    index={index}
                    optionGridData={e}
                    setSelectedOption={setSelectedOptionfromList}
                    userCMEDEntitlements={userCMEDEntitlements}
                    setIsOptionsGridViewModalOpen={
                      setIsOptionsGridViewModalOpen
                    }
                    setSelectedStrike={setSelectedStrike}
                    setOrderEntryData={setOrderEntryData}
                    orderEntryData={orderEntryData}
                    setOrderEntryData_Live={setOrderEntryData_Live}
                    orderAggressionCall={orderAggressionCall}
                    setorderAggressionCall={setorderAggressionCall}
                    orderAggressionPut={orderAggressionPut}
                    setorderAggressionPut={setorderAggressionPut}
                    setOpenOrderEntryModal={setOpenOrderEntryModal}
                    setOrderEntryType={setOrderEntryType}
                    setType={setType}
                    setopenOrderAggressionModal={setopenOrderAggressionModal}
                    selectedDerivativeType={selectedDerivativeType}
                    greeksData={data}
                    strikePriceATM={strikePriceATM}
                    nearestStrike={nearestStrikePrice.current}
                  />
                );
              })}
          </IonContent>
          <IonAlert
            isOpen={isUpdateStrikeAlertOpen}
            header="Update Mid Strike Price"
            onDidDismiss={() => {
              let atmInput = document.getElementById("atm") as HTMLInputElement;
              if (strikePriceATM) {
                if (isMidStrikeValue) {
                  //midstrike
                  atmInput.value = strikePrice;
                } else {
                  //atm
                  atmInput.value = "";
                }
              } else {
                //midstrike
                atmInput.value = strikePrice;
              }
              setIsUpdateStrikeAlertOpen(false);
            }}
            buttons={[
              {
                text: "UPDATE",
                role: "update",
                handler: (detail: any) => {
                  let atmInput = document.getElementById(
                    "atm",
                  ) as HTMLInputElement;
                  unsubscribeStrikeLadder(selectedOption);
                  setStrikePrice(atmInput?.value);
                  setStrikePriceATM(atmInput?.value === "");
                  setIsUpdateStrikeAlertOpen(false);
                  subscribeStrikeLadderCustom(atmInput?.value);
                },
              },
              {
                text: "CLOSE",
                role: "close",
                handler: () => {
                  let atmInput = document.getElementById(
                    "atm",
                  ) as HTMLInputElement;
                  if (strikePriceATM) {
                    if (isMidStrikeValue) {
                      //midstrike
                      atmInput.value = strikePrice;
                    } else {
                      //atm
                      atmInput.value = "";
                    }
                  } else {
                    //midstrike
                    atmInput.value = strikePrice;
                  }
                  setIsUpdateStrikeAlertOpen(false);
                },
              },
            ]}
            inputs={[
              {
                id: "atm",
                placeholder: "ATM",
                type: "number",
                value: strikePrice,
              },
            ]}
          ></IonAlert>
          <IonAlert
            trigger="remove-option-grid"
            header="Remove this option grid?"
            buttons={[
              {
                text: "DELETE",
                role: "delete",
                handler: (detail: any) => {
                  removeOptionGrid(selectedOption);
                },
              },
              {
                text: "CLOSE",
                role: "close",
              },
            ]}
          ></IonAlert>
          {selectedStrike !== undefined && (
            <OptionsGridViewModal
              setIsOptionsGridViewModalOpen={setIsOptionsGridViewModalOpen}
              isOptionsGridViewModalOpen={isOptionsGridViewModalOpen}
              selectedOption={selectedOption}
              strike={selectedStrike}
              optionGridData={optionGridData}
              userCMEDEntitlements={userCMEDEntitlements}
              orderEntryData={orderEntryData}
              orderEntryData_Live={orderEntryData_Live}
              openOrderEntryModal={openOrderEntryModal}
              setOpenOrderEntryModal={setOpenOrderEntryModal}
              orderEntryType={orderEntryType}
              setOrderEntryType={setOrderEntryType}
              type={type}
              setType={setType}
              greeksData={
                optionGridData?.find(
                  (item: any) => item?.key === selectedStrike,
                )?.data || []
              }
            />
          )}
          <IonFab
            activated={fabButtonOptions}
            slot="fixed"
            vertical="bottom"
            horizontal="end"
          >
            <IonFabButton
              color={"secondary"}
              size="small"
              style={{ opacity: 0.8 }}
              onClick={() => setFabButtonOptions(!fabButtonOptions)}
            >
              <IonIcon icon={ellipsisHorizontal}></IonIcon>
            </IonFabButton>
            <IonFabList side="top">
              <IonFabButton
                id="add-instrument"
                title="Add Instrument"
                onClick={() => {
                  unsubscribeStrikeLadder(selectedOption);
                  setselectedOption_Super(undefined);
                  setgreekType("4");
                  setSelectedExpiryId(2);
                  setFabButtonOptions(false);
                }}
              >
                <IonIcon icon={add}></IonIcon>
              </IonFabButton>

              <IonFabButton
                title={"Remove Option Grid"}
                id="remove-option-grid"
                onClick={() => setFabButtonOptions(false)}
              >
                <IonIcon color="danger" icon={trashOutline}></IonIcon>
              </IonFabButton>
              <IonFabButton
                title={"Go to Strike"}
                onClick={() => {
                  setIsUpdateStrikeAlertOpen(true);
                  setFabButtonOptions(false);
                  CMEDfirebaseLogEvent(
                    firebaseEventConfig.CMEDComponentNames.CMED_OPTIONS_GRID,
                    firebaseEventConfig.eventNames.CMED_OPTIONS_GRID
                      .CMED_OPTIONS_GRID_GO_TO_STRIKE,
                  );
                }}
              >
                <IonIcon icon={trendingUpOutline}></IonIcon>
              </IonFabButton>
              <IonFabButton
                title={"Go to ATM"}
                onClick={(detail: any) => {
                  unsubscribeStrikeLadder(selectedOption);
                  subscribeStrikeLadderCustom("");
                  setStrikePrice("");
                  setStrikePriceATM(true);
                  setFabButtonOptions(false);
                  CMEDfirebaseLogEvent(
                    firebaseEventConfig.CMEDComponentNames.CMED_OPTIONS_GRID,
                    firebaseEventConfig.eventNames.CMED_OPTIONS_GRID
                      .CMED_OPTIONS_GRID_GO_TO_ATM,
                  );
                }}
              >
                <IonText style={{ size: "small" }}>ATM</IonText>
              </IonFabButton>
            </IonFabList>
          </IonFab>
        </>
      ) : (
        <IonContent>
          <Skeleton__OptionsGrid />
        </IonContent>
      )}
    </React.Fragment>
  );
};

export default OptionsGrid;
